<template>
  <el-container>
    <div class="view">
      <div class="enterpriseIndex">
        <div class="flexLR">
          <div style="width: 100%">
            <el-card class="box-card">
              <div slot="header">
                <el-row>
                  <el-col :span="9">
                    <el-row>
                      <el-col :span="5">
                        <el-select filterable v-model="manager" @change="change2">
                          <el-option :label="$t('我的主页.全部')" value="2"></el-option>
                          <el-option :label="$t('我的主页.我加入的')" value="0"></el-option>
                          <el-option :label="$t('我的主页.我管理的')" value="1"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="19">
                        <el-row>
                          <el-col :span="15" :offset="2">
                            <el-input :placeholder="$t('我的主页.请输入项目名称')" class="search-input" v-model="query">
                              <el-button style="color: #fff" class="jb" slot="append" icon="el-icon-search"
                                @click="GetMyIndexList"></el-button>
                            </el-input>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="9" :offset="6">
                    <el-row>
                      <el-col :span="12">
                        <el-select filterable v-model="rank" @change="changeRank">
                          <el-option :label="item.label" :value="item.value" v-for="item in options"
                            :key="item.value"></el-option>
                        </el-select>
                      </el-col>
                      <!-- <el-col :span="8">
                        <el-button @click="moren">默认</el-button>
                        <el-button @click="mapshow">地图</el-button>
                      </el-col> -->
                    </el-row>
                  </el-col>
                </el-row>
              </div>
              <el-row :style="{
                position: showAll ? 'absolute' : '',
                zIndex: showAll ? 2 : 0,
                left: 0,
                top: 0,
                width: '100%',
                height: '100%',
              }" v-show="mapDrawer">
                <transition name="mapDT">
                  <div id="map" v-show="mapDrawer"></div>
                </transition>
              </el-row>
              <el-row v-if="!mapDrawer" class="height710">
                <div v-for="(item, index) in testList" :key="index" @click="pushProject(item, index)">
                  <el-col :span="4" class="pos-rel">
                    <el-card :body-style="{ padding: '0px', cursor: 'pointer' }">
                      <img :src="$store.state.baseUrl + item.proj24" @error="replaceImage" class="image" />
                      <div class="enterpriseIndexIcon">
                        <span :title="item.proj07">{{ item.proj07 }}</span>
                        <p style="margin-top: 3px">{{ item.proj20N ? item.proj20N : '- -' }}</p>
                        <i v-if="item.prou07 != 1">{{ $t('我的主页.协作') }}</i>
                        <i v-else class="gl">{{ $t('我的主页.管理') }}</i>
                      </div>
                    </el-card>
                  </el-col>
                </div>
                <!-- <el-col :span="4" class="pos-rel" v-if="$store.state.pid">
                  <el-card shadow="never" :body-style="{ padding: '0px', cursor: 'pointer' }">
                    <div style="height: 214px;text-align: center;line-height: 214px;font-size: 61px;">
                      <i style="color: #589bfa" class="el-icon-plus" @click="handelAdd"></i>
                    </div>
                  </el-card>
                </el-col> -->
              </el-row>
            </el-card>
          </div>
          <div style="width: 20px">
            <img width="10" @click="SetHomeIcon" :style="{ transform: !ProjectIcon ? `rotate(180deg)` : `` }"
              style="display: block; margin: 0 auto; cursor: pointer" src="/img/homeIcon.png" alt="" />
          </div>
          <div :style="ProjectIcon ? 'width:30%;height:100%' : 'display:none;height:100%'
            ">
            <!-- 这里是平台公告 -->
            <el-card class="box-card" style="height: 98%">
              <div slot="header" class="height28">
                <!-- 标题 -->
                <span class="font-sz18">{{ $t('我的主页.最近打开的文件') }}</span>
              </div>
              <div style="height: 720px;overflow: auto;">
                <p v-for="(item, index) in recentFileList.slice(0, 50)" :key="index" style="height: 25px;">
                  <el-button @click="documentOpen(item.file)" type="text"
                    :title="item.file.prfl02 ? item.file.prfl02 : item.file.name"
                    style="width: 350px;text-align: left;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                    <img style="width: 15px; height: 15px;margin: -5px 3px 0 0;"
                      :src="documentIcon(item.file.ext.slice(item.file.ext.lastIndexOf('.') + 1).toLowerCase())" />
                    {{ item.file.prfl02 ? item.file.prfl02 : item.file.name }}</el-button>
                </p>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <el-drawer title="邀请处理" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <el-table :data="inviList" class="width100">
        <el-table-column prop="CompanyName" label="公司名称"></el-table-column>
        <el-table-column prop="DeptName" label="部门名称"></el-table-column>
        <el-table-column label="是否接受">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="consent(scope.row)">同意</el-button>
            <el-button size="mini" type="danger" plain @click="Noconsent(scope.row)">拒绝</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="申请加入项目" :visible.sync="dialogVisible" width="40%" center>
      <el-form :rules="rules" ref="formLabel" label-position="top" :model="formLabel" style="margin-left: 100px">
        <el-form-item label="请输入项目编码：" prop="projectcode">
          <el-input v-model="formLabel.projectcode" placeholder="只支持精确搜索，不能模糊搜索" autocomplete="off"
            style="width: 450px"></el-input>
        </el-form-item>
        <el-form-item label="选择项目组织架构：" prop="deptid">
          <el-select style="width: 350px" v-model="formLabel.deptid" placeholder="请选择">
            <el-option v-for="item in dept" :key="item.prde01" :label="item.prde03" :value="item.prde01"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择项目职位：" prop="jobid">
          <el-select style="width: 350px" v-model="formLabel.jobid" placeholder="请选择">
            <el-option v-for="item in job" :key="item.pror01" :label="item.pror02" :value="item.pror01"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button style="float: right" type="text" @click="GetApplyRecord">申请记录</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitProject('formLabel')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="申请记录" :visible.sync="application" width="50%" center>
      <div style="height: 300px; overflow: auto;hiddenScroll">
        <el-row v-for="(project, index) in inFromProject" :key="index"
          style="line-height: 40px; border-bottom: 1px solid #e8e8e8">
          <el-col :span="10">
            <span>您已</span>
            <span style="color: #42a3fd">{{ project.Msg.substr(2, 2) }}</span>
            <span>加入</span>
            <span style="color: #42a3fd">{{ project.CompanyorProject }}</span>
            <span>项目</span>
          </el-col>
          <el-col :span="6">{{ project.Time }}</el-col>
          <el-col :span="2">
            {{
              project.State == 1
                ? "已通过"
                : project.State == 0
                  ? "已拒绝"
                  : "审核中"
            }}
          </el-col>
          <el-col :span="6" style="display: flex">
            <el-popconfirm title="要催办该条请求吗？" @confirm="SetUrge1(firm.Id)">
              <el-button slot="reference" type="text">催办</el-button>
            </el-popconfirm>
            <el-popconfirm title="要撤销该条请求吗？" @confirm="DelApply(firm.Id)">
              <el-button slot="reference" type="text" style="color: red; margin: 0 20px">撤销</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="application = false">取 消</el-button>
        <el-button type="primary" @click="application = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import personal from "../my/personal";
import dayjs from "dayjs";
import {
  GetMyIndex,
  GetNotice,
  GetInvite,
  HandleInvite,
  GetRoleList,
  AddNoiceReads,
  BindWeChat,
  ApplyToJoinProject,
  GetProjectDeptAndJob,
  GetApplyRecord,
  SetUrge,
  DelApply,
  GetRecentlyFile,
  AddRecentlyFile
} from "@/setAxios";
export default {
  components: {
    personal,
  },
  name: "admin",
  data() {
    return {
      showAll: false,
      showNotices2: false,
      NoticesInfo: "",
      mapDrawer: false,
      disabled: true,
      options: [
        { label: this.$t('我的主页.按时间排序'), value: 1 },
        { label: this.$t('我的主页.按合同排序'), value: 3 },
        { label: this.$t('我的主页.按规模排序'), value: 2 },
        { label: this.$t('我的主页.按人力排序'), value: 4 },
      ],
      JobName: "",
      drawer: false,
      direction: "rtl",
      // 这里是排序
      rank: 1,
      manager: "2",
      query: "",
      testList: [],
      inviList: [],
      option: {
        step: 1,
        limitMoveNum: 9,
        openTouch: false,
        waitTime: 1,
        direction: 1,
        singleHeight: 35,
      },
      loading: false,
      dialogVisible: false,
      formLabel: {
        projectcode: "",
        deptid: "",
        jobid: "",
      },
      job: [],
      dept: [],
      rules: {
        projectcode: [
          { required: true, message: "请输入项目编码", trigger: "blur" },
        ],
        deptid: [
          { required: true, message: "请选择项目组织架构", trigger: "change" },
        ],
        jobid: [
          { required: true, message: "请选择项目职位", trigger: "change" },
        ],
      },
      application: false,
      ProjectIcon: true,
      inFromProject: [],
      recentFileList: [],
    };
  },
  async created() {
    this.IsHomeIcon();
    window.pushMapProject = this.pushMapProject;
    localStorage.url = this.$store.state.baseUrl;
    this.$store.state.btnStyle = ["btnss", "btns", "btns", "btns"];
    let params = {
      uid: localStorage.getItem("id"),
    };
    GetInvite({ params }).then((res) => {
      if (res.Data && res.Data.length > 0) {
        this.drawer = true;
        this.inviList = res.Data;
      }
    });


    this.GetMyIndexList();
    this.GetRecentlyFile();
    var code = window.location.search;
    if (code.indexOf("code") > 0) {
      code = window.location.search.substr(1).split("=")[1].split("&")[0];
      let params = {
        uid: localStorage.id,
        code: code,
      };
      BindWeChat(params).then((res) => {
        if (res.Code == 0) {
          this.$message({
            type: "danger",
            message: res.Message,
          });
        } else {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            text: "绑定成功...",
          });
        }
        setTimeout(() => {
          window.location.href = location.origin + "/#/";
        }, 2000);
      });
    }
  },
  mounted() {
  },
  //利用计算属性
  computed: {
    pidupdata() {
      return this.$store.state.pid;
    },
  },
  //监听执行
  watch: {
    pidupdata(newVal, oldVal) {
      this.GetMyIndexList();
    },
    // 根据输入值的不同获取公司组织架构和企业职位
    formLabel: {
      handler(newVal, oldVal) {
        let params = {
          projectcode: newVal.projectcode,
        };
        GetProjectDeptAndJob({ params }).then((res) => {
          if (res.Data) {
            this.job = res.Data.job;
            this.dept = res.Data.dept;
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    documentIcon(ext) {
      switch (ext) {
        case "png":
        case "jpg":
        case "jpeg":
          return require('@/assets/img/图标/jpg.svg')
        case "dwg":
        case "dxf":
          return require('@/assets/img/图标/dwg.svg')
        case "mp4":
          return require('@/assets/img/图标/视频.svg')
        case "docx":
        case "doc":
          return require('@/assets/img/图标/doc.svg')
        case "xlsx":
        case "xls":
          return require('@/assets/img/图标/xls.svg')
        case "rvt":
        case "rfa":
          return require('@/assets/img/图标/rvt.svg')
        case "skp":
          return require('@/assets/img/图标/skp.svg')
        case "txt":
          return require('@/assets/img/图标/txt.svg')
        case "pdf":
          return require('@/assets/img/图标/pdf.svg')
        default:
          return require('@/assets/img/图标/文档.svg')
      }
    },
    replaceImage(e) {
      e.target.src = require('@/assets/img/default.png');
    },
    async documentOpen(item) {
      AddRecentlyFile({ fileId: item.guid, userId: this.$store.state.uid, time: dayjs().format("YYYY-MM-DD HH:mm:ss") })
      if (item.name) {
        let params = `fileId=${item.guid}&path=${item.path}&xid=${item.xid}&name=${item.name}`;
        params = Base64.encode(params);
        let url = window.location.origin + `/#/viewMyDocument?Code=${params}`;
        window.open(url, "_blank");
      } else {
        let params = `fileId=${item.prfl01}&guid=${item.guid}&path=${item.prfl04}&xid=${item.prfl05}&name=${item.prfl02}`;
        params = Base64.encode(params);
        let url = window.location.origin + `/#/viewFileModel?Code=${params}`;
        window.open(url, "_blank");
      }

    },
    GetRecentlyFile() {
      GetRecentlyFile({ uid: this.$store.state.uid }).then((res) => {
        this.recentFileList = res.Data.filter(w => w.file != null);
      });
    },
    SetHomeIcon() {
      localStorage.setItem("HomeIcon", !this.ProjectIcon);
      this.IsHomeIcon();
    },
    IsHomeIcon() {
      if (localStorage.getItem("HomeIcon") != null) {
        this.ProjectIcon = JSON.parse(localStorage.getItem("HomeIcon"));
      } else {
        localStorage.setItem("HomeIcon", true);
        this.ProjectIcon = true;
      }
    },
    //
    NoticeShow(data) {
      AddNoiceReads({ id: data.noti01 });
      this.showNotices2 = true;
      this.NoticesInfo = data.noti05;
    },
    mapshow() {
      var _this = this;
      this.mapDrawer = !this.mapDrawer;
      setTimeout(() => {
        var map = new AMap.Map("map", {
          resizeEnable: true,
        });
        map.setZoomAndCenter(4, [108.946609, 34.262324]);
        AMap.plugin(["AMap.ToolBar", "AMap.ControlBar"], function () {
          map.addControl(new AMap.ToolBar());
        });
        this.testList.forEach((v) => {
          $.ajax({
            url: `https://restapi.amap.com/v3/geocode/geo?address=${v.proj13}&output=JSON&key=0c8a1293a4c780c6a4eb13ec0bc4b34e`,
            type: "GET",
            dataType: "JSON",
            processData: false,
            contentType: false,
            success: function (obj) {
              if (obj.geocodes && obj.geocodes.length > 0) {
                var position = obj.geocodes[0].location.split(",");
                var marker = new AMap.Marker({
                  map: map,
                  // id: v.proj01,
                  position: position,
                });
                // var infoWindow = new AMap.InfoWindow({
                //   anchor: "middle-left",
                //   content: `<div><img src="${_this.$store.state.baseUrl+v.proj24}" style="width:77px;height:77px;">${v.proj02}</div>`
                // });
                // AMap.event.addListener(marker, "mouseover", function() {
                //   infoWindow.open(map, marker.getPosition());
                // });
                var info = [];
                //(v, "vvv");

                info.push(
                  '<div style="display:flex;align-items:center" ><div><img style="float:left;width:80px;height:80px;cursor: pointer;" onclick="window.pushMapProject(\'' +
                  v.proj01 +
                  '\')" src="' +
                  `${_this.$store.state.baseUrl + v.proj24}` +
                  '"/></div>'
                );
                info.push(
                  '<div style="padding:7px 0px 0px 7px;"><h4>项目编号：' +
                  `${v.proj02}` +
                  "</h4><h4>项目名称：" +
                  `${v.proj03}` +
                  "</h4>" +
                  "</div></div>"
                );
                var infoWindow = new AMap.InfoWindow({
                  anchor: "top-center",
                  content: info.join(""),
                });
                AMap.event.addListener(marker, "mouseover", function () {
                  infoWindow.open(map, marker.getPosition());
                });
              }
            },
          });
        });
      }, 100);
    },
    moren() {
      this.rank = 1;
      this.GetMyIndexList();
      this.mapDrawer = false;
    },
    changeRank(data) {
      this.rank = data;
      this.GetMyIndexList();
    },
    consent(row) {
      let params = {
        uid: localStorage.getItem("id"),
        qid: row.invi06,
        state: 1,
      };
      HandleInvite({ ...params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "已经接受邀请",
          });
          this.drawer = false;
        } else if (res.Code == -2) {
          this.$message({
            type: "warning",
            message: "企业内部人员已满",
          });
          this.drawer = false;
        }
      });
    },
    Noconsent(row) {
      let params = {
        uid: localStorage.getItem("id"),
        qid: row.invi06,
        state: 0,
      };
      HandleInvite({ ...params }).then((res) => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "已经拒绝邀请",
          });
          this.drawer = false;
        }
      });
    },
    pushMapProject(xid) {
      localStorage.xid = xid;
      this.$router.push({
        path: "/userControl",
      });
    },
    // 点击项目进行跳转
    pushProject(item) {
      this.$store.state.xidName = item.proj07;
      localStorage.setItem("xid", item.proj01);
      this.$store.state.xid = item.proj01;
      this.$store.state.btnStyle[0] = "btns";
      this.$store.state.btnStyle[1] = "btnss";
      this.$store.state.btnStyle[2] = "btns";
      this.$store.state.btnStyle[3] = "btns";
      localStorage.setItem("XmName", item.proj07);
      localStorage.setItem("XmBh", item.proj02);
      let params = {
        qid: localStorage.pid,
        xid: localStorage.xid,
        uid: localStorage.id,
      };
      GetRoleList(params).then((res) => {
        if (res.Data.length == 0) {
          this.$message({
            type: "warning",
            message: this.$t('common.当前用户在此项目中未设置角色请联系管理员'),
          });
          return false;
        }
        this.$store.state.isClickProject = true;
        this.$store.state.jobs = res.Data;
        this.$store.state.roleName = res.Data[0].roleName;
        if (res.Data[0].isPM) {
          this.$store.state.isProject = true;
        } else {
          this.$store.state.isProject = false;
        }
        this.$store.state.permissions =
          res.Data[0].roleRight == null
            ? null
            : res.Data[0].roleRight.split(",");
        this.$router.push({
          path: "/userControl",
        });
      });
    },
    // 这里是更改加入的和管理的
    change2(data) {
      //(data);
      this.manager = data;
      this.GetMyIndexList();
    },
    // 这里是获取我的主页项目列表
    GetMyIndexList() {
      if (localStorage.pid || this.$store.state.pid) {
        let params = {
          secahword: this.query,
          manager: this.manager,
          uid: localStorage.getItem("id"),
          pid: localStorage.pid || this.$store.state.pid,
          type: this.rank,
        };
        GetMyIndex({ params }).then((res) => {
          this.testList = res.Data;
        });
      }
    },
    // 创建项目
    handelAdd() {
      this.dialogVisible = true;
    },
    submitProject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const val = this.formLabel;
          let params = {
            projectcode: val.projectcode,
            deptid: val.deptid,
            jobid: val.jobid,
          };
          ApplyToJoinProject(params).then((res) => {
            this.$message({
              type: "success",
              message: "申请加入项目成功",
            });
            this.dialogVisible = false;
            this.formLabel = {
              projectcode: "",
              deptid: "",
              jobid: "",
            };
          });
        }
      });
    },
    GetApplyRecord() {
      this.application = true;
      let params = {
        type: 2,
      };
      GetApplyRecord({ params }).then((res) => {
        if (res.Code > 0) {
          this.inFromProject = res.Data;
        }
      });
    },
    handleClose() {
      this.drawer = false;
    },
    handleClose1() {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.application = false;
          done();
        })
    },
    // 催办
    SetUrge1(id) {
      let params = {
        applyid: id,
        state: 1,
      };
      SetUrge(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "催办成功",
          });
          this.GetApplyRecord();
        }
      });
    },
    // 撤销申请
    DelApply(id) {
      let params = {
        applyid: id,
      };
      DelApply(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "撤销申请成功",
          });
          this.GetApplyRecord();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
// /deep/ .el-drawer__body {
//   overflow: auto;
// }

/deep/.el-card__body {
  min-height: 90% !important;
}

.amap-info-close {}

.admin-bj {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.title-left {
  margin-left: 20px;
}

.menu-left {
  margin-right: 20px;
  width: 100%;
}

.el-container {
  width: 100%;
  height: 100%;
}

.el-header {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0px;

  .el-col-1 {
    margin-left: 30px;

    img {
      height: 60px;
    }
  }

  .el-col-4 {
    font-weight: 700;
    font-style: normal;
    color: #000000;
    font-size: 28px;
  }
}

.el-aside {
  background-color: #bfcbd9;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.view {
  background-color: #f4f4f5;
  width: 100%;
  overflow: auto;
}

.breadcrumb-container {
  float: left;
}

.right-menu {
  float: right;
  width: 100%;
  height: 60px;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;

    .avatar-wrapper {
      margin-top: 10px;
      position: relative;
      height: 45px;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

.enterpriseIndex {
  // padding: 10px;
  padding: 10px 10px 0 10px;
  height: 98%;
}

.item {
  position: relative;
  margin-top: 40px;

  span {
    position: absolute;
    background: #1a78a9;
    display: block;
    height: 30px;
    width: 70px;
    line-height: 30px;
    border-bottom-right-radius: 40%;
    color: #fff;
    top: 0;
    left: 0;
  }

  .el-rate {
    position: absolute;
    top: 80%;
    left: 0;
  }
}

.Pa {
  line-height: 25px;
  height: 300px;
  overflow: auto;

  img {
    width: 32px;
    height: 32px;
  }
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
  //height
  height: 160px;
}

.el-card {
  height: 98%;
}

// .seamless-warp2 {
//   overflow: hidden;
//   height: 25px;
//   width: 380px;
//   ul.item {
//     width: 580px;
//     li {
//       float: left;
//       margin-right: 10px;
//       color:#000000
//     }
//   }
// }
/deep/ .el-table .warning-row {
  background: oldlace;
}

/deep/ .el-table .success-row {
  background: #f0f9eb;
}

#map {
  width: 100%;
  height: 740px;
}

/deep/ .el-drawer {
  img {
    width: 100%;
    height: 100%;
  }
}

.mapDT-enter,
.mapDT-leave-to {
  // transform: translateX(10px);
  opacity: 0;
}

.enterpriseIndexIcon {
  padding: 8px 14px 5px 14px;
  box-sizing: border-box;
  background: linear-gradient(to right, #4f6dfa, #5aa6f9);
  color: #fff;

  span {
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .gl {
    background-color: #003565;
  }

  i {
    display: block;
    position: absolute;
    top: 11px;
    right: 11px;
    font-size: 12px;
    // width: 40px;
    padding: 1px 5px;
    height: 20px;
    background-color: #e6a23c;
    text-align: center;
    border-radius: 0 3px 0 10px;
    color: #ffffff;
  }
}

.NoticeShowStyle {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-size: 16px;
}

// 新增
.height710 {
  // height: 732px;
  height: 710px;
  // max-height: 95%;
  // overflow-y: auto;
}

.pos-rel {
  position: relative;
  padding: 10px;
  border-radius: 5px;
  transition: all 0.3s;
}

.pos-rel:hover {
  box-shadow: 0px 0px 5px #00000060;
  transition: all 0.3s;
}

.height28 {
  height: 28px;
}

.font-sz18 {
  font-size: 18px;
}

.ovf-hid {
  overflow: hidden;
}

.font-sz16 {
  font-size: 16px;
}

.cor63-fonsz14 {
  color: #637fff;
  font-size: 14px;
}

.float-r {
  float: right;
}

.iconfont {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.w20-h24 {
  width: 20px;
  height: 24px;
}

.center {
  text-align: center;
}

.cor-fd7 {
  color: #fd7f20;
}

.width100 {
  width: 100%;
}

.fontw70-sz15 {
  font-weight: 700;
  font-size: 14px;
}

.one {
  padding: 0 20px;
  height: 100vh;
  overflow: auto;
}

.jb {
  background: linear-gradient(to right, #2f2f2f, #535353);
  height: 30px;
}

.H100 {
  height: 100%;
}

.flexLR {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
